export default import.meta.ROLLUP_FILE_URL_Ddte4eqB